var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"rounded-lg ppim23-card d-flex align-center justify-center",attrs:{"outlined":""}},[_c('h2',{staticClass:"py-10 red--text text--lighten-2"},[_vm._v(_vm._s(this.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }